import { alertHtml } from "./virtual";
import { cr } from "fire-wind-water";

/*
 *
 * */
export class Elem {
  elem: HTMLElement;
  wrap: HTMLElement;

  create(sett: any): void {
    const oFragment = document.createDocumentFragment();
    const arr = this.createVirtual(alertHtml, sett);
    cr.each(arr, (o) => {
      oFragment.appendChild(o);
    });
    document.body.appendChild(oFragment);
  }

  createVirtual(
    a: { [label: string]: any },
    sett: { [label: string]: any }
  ): HTMLElement[] {
    const arr: HTMLElement[] = [];
    cr.each(a, (o) => {
      if (o.cs && sett[o.cs] !== 1) {
        return;
      }
      const el = document.createElement(o.h);
      el.className = o.c;
      if (o.id) {
        el.id = o.id;
      }
      if (o.r) {
        this[o.r] = el;
      }
      if (o.lr) {
        el.innerHTML = sett[o.lr] || "";
      }
      if (o.e) {
        cr.each(o.e, (d) => {
          if (d.r) {
            el.addEventListener(d.t, d.e(this[d.r]), false);
          }
          if (d.f) {
            el.addEventListener(d.t, d.e(sett[d.f]), false);
          }
        });
      }
      if (o.s) {
        const c = this.createVirtual(o.s, sett);
        cr.each(c, (d) => {
          el.appendChild(d);
        });
      }
      arr.push(el);
    });
    return arr;
  }

  prevent(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
  }

  merge(
    html: string,
    ocn: any,
    ncn: any,
    sett: { [label: string]: any }
  ): void {
    const conf = {
      html,
      okValue: sett.ok || "确定",
      noValue: sett.no || "取消",
      ok: ocn,
      no: ncn,
      confirm: sett.confirm,
    };
    this.create(conf);
  }

  show(): void {
    this.elem.style.display = "block";
    setTimeout(() => {
      this.wrap.style.opacity = "1";
      this.wrap.style.transform = "translateX(-50%) translateY(-50%)";
    }, 0);
  }

  hide(cn: any): void {
    this.wrap.style.opacity = "0";
    this.wrap.style.transform = "translateX(-50%) translateY(-100%)";
    setTimeout(() => {
      this.elem.style.display = "none";
      document.body.removeChild(this.elem);
      cn();
    }, 200);
  }
}
